<script>
import InfoCardsItem from "@js/components/Sections/InfoCards/Components/InfoCardsItem.vue";
import InfoCardsEmptyItem from "@js/components/Sections/InfoCards/Components/InfoCardsEmptyItem.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";


export default {
    name: "InfoCards",
    components: {OnlyMobile, OnlyDesktop, InfoCardsEmptyItem, InfoCardsItem},
    props: {
        items_group_1: {
            required: true,
            type: Array,
        },
        items_group_2: {
            required: false,
            type: Array,
        }
    }
}
</script>

<template>
    <div class="overflow-hidden">
        <OnlyDesktop>
            <div class="container">
                <div class="grid grid-cols-3 lg:grid-cols-4 gap-10 xl:-me-[350px]">
                    <InfoCardsItem v-for="(item, index) in items_group_1"
                                   :title="item.title"
                                   :description="item.description"
                                   :logo="item.logo"
                                   :key="index"/>
                    <InfoCardsEmptyItem/>
                </div>
            </div>
            <div class="container">
                <div class="grid grid-cols-3 lg:grid-cols-4 gap-10 mt-10 xl:-ms-[350px]">
                    <InfoCardsEmptyItem/>
                    <InfoCardsItem v-for="(item, index) in items_group_2"
                                   :title="item.title"
                                   :description="item.description"
                                   :logo="item.logo"
                                   :key="index"/>
                </div>
            </div>
        </OnlyDesktop>
        <OnlyMobile>
            <div class="container">
                <div class="grid grid-cols-1 gap-5 mt-10">
                    <InfoCardsItem v-for="(item, index) in [...items_group_1, ...items_group_2]"
                                   :title="item.title"
                                   :description="item.description"
                                   :logo="item.logo"
                                   :key="index"/>
                </div>
            </div>
        </OnlyMobile>
    </div>
</template>

<style scoped lang="scss">

</style>
